/* klaasje-social
   -------------
   De gebogen wand van social-kaarten. Elke kaart draagt vijf getallen
   (--fx, --fy, --fr, --ft, --fs) en de CSS maakt daar een transform van:
   opzij, draai om de verticale as, diepte, schaal. Liquid schrijft de
   rusttoestand mee, dus de wand staat meteen goed; deze JS doet alleen
   het schuiven (pijlen, vegen, slepen) en het binnenkomen. Geen hover:
   we bouwen voor de telefoon, en een duim heeft daar niets aan.

   x en y zijn veelvouden van de kaart zelf, niet van rem: in dit thema
   staat de root op 62.5% (Dawn), dus rem is hier 10px. De diepte t is
   een veelvoud van de kaartbreedte; positief is naar de kijker toe.
*/

/* Eigen scope: thema-scripts delen één globale scope, en een top-level
   const die ook in een ander script staat is een SyntaxError waardoor
   het hele bestand niet draait (zie CLAUDE.md). */
(() => {

  const MAX_VISIBLE = 7;

  /* De zeven plekken op de wand, van links naar rechts.

     Berekend, niet gestemd: elke kaart is een koorde van dezelfde kromme
     een cover flow, met de getallen uit de coverflow-component: de draai is
     44° x afstand^0,56 (44, 65, 81, dan afgetopt) en de diepte 0,6 x
     dezelfde macht, 1,05 kaartbreedte opzij per stap, perspectief 3 in de
     CSS. De BUITENrand komt naar de kijker; rechts draait dus negatief.
     Draai je dat om, dan kijk je in een kom in plaats van langs een rij,
     terwijl alle breedtes en hoogtes gelijk blijven. Een oplopende hoek (de gebogen
     wand die hier eerder stond) klapt de buitenste kaarten dicht tot
     streepjes; op een vaste hoek blijft de derde even leesbaar als de
     eerste. Links draait negatief (linkerrand naar achteren), rechts
     positief. De zesde waarde is de dekking, die per stap naar buiten
     0,1 zakt. Teruggerekend uit het voorbeeld, script in de scratchpad
     (flow.py).

     Dezelfde tabel staat in sections/klaasje-social.liquid. Wijzig je
     hem, wijzig hem dan op allebei de plekken. */
  const SLOTS = [
    { x: -3.15, y: 0, r: 81.4, t: -1.126, z: 1, opacity: 0.7 },
    { x: -2.1, y: 0, r: 64.9, t: -0.885, z: 2, opacity: 0.8 },
    { x: -1.05, y: 0, r: 44, t: -0.6, z: 3, opacity: 0.9 },
    { x: 0, y: 0, r: 0, t: 0, z: 4, opacity: 1 },
    { x: 1.05, y: 0, r: -44, t: -0.6, z: 3, opacity: 0.9 },
    { x: 2.1, y: 0, r: -64.9, t: -0.885, z: 2, opacity: 0.8 },
    { x: 3.15, y: 0, r: -81.4, t: -1.126, z: 1, opacity: 0.7 },
  ];

  const OUT = 2.6; // hoe ver een kaart buiten beeld staat bij het schuiven
  // Diep genoeg om achter de buitenste kaart (t = -1,126) te vallen: wat
  // verdwijnt hoort naar achteren te zakken, niet naar voren.
  const OUT_T = -1.6;
  const SWIPE = 40; // px: korter is een tik, langer is een veeg

  /* ── De Instagram-feed ─────────────────────────────────────
     Staat er een feed-link op de sectie, dan vervangen we de foto van
     elke kaart door de nieuwste post. Instagram zelf kan dat niet
     leveren aan een thema: daar hoort een token bij dat elke 60 dagen
     ververst moet worden, en dat hoort niet in de paginabron. De link
     wijst dus naar iets wat dat token bewaakt en kale JSON teruggeeft
     (instagram-feed/ in deze repo draait dat op Cloudflare).

     Wat er niet komt is even belangrijk: de kaarten zijn er al voor de
     feed binnen is, met de foto's uit de blokken erin. Mislukt het
     ophalen, duurt het te lang of komt er onzin terug, dan gebeurt er
     domweg niets en blijft dat staan. Een lege wand is geen optie.

     De volgorde is die van Instagram zelf, nieuwste eerst, van links
     naar rechts. De wand start in het midden, dus de nieuwste post
     staat links daarvan en is één pijl weg. */
  const FEED_TIMEOUT = 6000;

  /* Zo min mogelijk eisen aan de vorm: een kale lijst, of een lijst
     onder data (Instagram zelf) of posts (de meeste diensten). */
  function feedPosts(json) {
    if (Array.isArray(json)) return json;
    if (Array.isArray(json?.data)) return json.data;
    if (Array.isArray(json?.posts)) return json.posts;
    return [];
  }

  /* Een reel of video heeft geen bruikbare media_url voor een <img>;
     daar is thumbnail_url het beeld. */
  function feedImage(post) {
    if (post.media_type === 'VIDEO' && post.thumbnail_url) return post.thumbnail_url;
    return post.media_url || post.thumbnail_url || '';
  }

  /* Het hartje van Instagram, als losse tekening zodat het ook in de
     vergrote weergave klopt. Geen bestand: dit is het enige icoon dat de
     JS zelf neerzet. */
  const HART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
    + '<path d="M12 21s-7.5-4.7-9.6-9A5.4 5.4 0 0 1 12 6.2 5.4 5.4 0 0 1 21.6 12c-2.1 4.3-9.6 9-9.6 9z"/></svg>';

  /* De luidspreker op de vergrote video, aan en gedempt. Geen emoji: die
     tekent elk systeem anders en in kleur, en dat vloekt met de rest. */
  const LUIDSPREKER = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
    + '<path d="M4 9h3.5L12 5.2v13.6L7.5 15H4z" fill="currentColor"/>'
    + '<path d="M15.5 9.2a4 4 0 0 1 0 5.6M18 6.7a7.5 7.5 0 0 1 0 10.6" fill="none"'
    + ' stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  const LUIDSPREKER_UIT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
    + '<path d="M4 9h3.5L12 5.2v13.6L7.5 15H4z" fill="currentColor"/>'
    + '<path d="M16 9.5l5 5M21 9.5l-5 5" fill="none" stroke="currentColor"'
    + ' stroke-width="1.8" stroke-linecap="round"/></svg>';

  /* Rechtsboven op elke post: een reel krijgt het filmpje, al het andere
     (foto, carrousel) het fototje. Zelf getekend, met currentColor, net als
     het hartje. */
  const ICOON_VIDEO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"'
    + ' stroke-linejoin="round" aria-hidden="true" focusable="false">'
    + '<rect x="3" y="3" width="18" height="18" rx="5"/>'
    + '<path d="M10 8.6v6.8l5.6-3.4z" fill="currentColor" stroke="none"/></svg>';
  const ICOON_FOTO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"'
    + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'
    + '<rect x="3" y="3" width="18" height="18" rx="5"/>'
    + '<circle cx="9" cy="9" r="1.6" fill="currentColor" stroke="none"/>'
    + '<path d="M4 17l4.5-4.5 3.5 3.5 2.5-2.5L21 19"/></svg>';

  function isVideoPost(post) {
    return post.media_type === 'VIDEO';
  }

  function typeIcoon(post) {
    return isVideoPost(post) ? ICOON_VIDEO : ICOON_FOTO;
  }

  /* 147 blijft 147, maar 1234 wordt 1,2k: op een kaart van 200px is een
     getal van vier cijfers een muur. */
  function telling(n) {
    if (typeof n !== 'number' || n < 0) return '';
    if (n < 1000) return String(n);
    if (n < 10000) return String(Math.round(n / 100) / 10).replace('.', ',') + 'k';
    return Math.round(n / 1000) + 'k';
  }

  function feedAlt(post) {
    const caption = (post.caption || '').trim();
    if (!caption) return 'post op Instagram';
    const first = caption.split('\n')[0];
    return first.length > 120 ? first.slice(0, 117) + '...' : first;
  }

  /* Pas verwisselen als het beeld echt gedecodeerd is: anders zie je op
     een trage lijn een lege kaart tussen de terugval en de post in. */
  function fillCard(card, post) {
    const src = feedImage(post);
    if (!src) return Promise.resolve();

    const img = new Image();
    img.className = 'klaasje-social__img';
    img.alt = feedAlt(post);
    /* Bewust geen loading="lazy": deze img hangt nog niet in de pagina,
       en WebKit begint aan zo'n losse lazy afbeelding domweg nooit. Dan
       komt decode() nooit terug en blijft de terugval staan, zonder
       foutmelding. In Chrome viel dat niet op. Wachten hoeft hier ook
       niet meer: we halen de feed pas op als de wand in de buurt is. */
    img.decoding = 'async';
    img.draggable = false;
    img.src = src;

    const ready = img.decode ? img.decode() : Promise.resolve();
    return ready.catch(() => {}).then(() => {
      if (!img.naturalWidth) return; // niet geladen: terugval laten staan
      const old = card.querySelector('.klaasje-social__img, .placeholder-svg');
      if (old) old.replaceWith(img);
      else card.prepend(img);

      /* Het bijschrift hoort bij de foto uit het blok, niet bij deze
         post, dus het gaat mee weg. Onze eigen feed heeft ook geen
         bronvermelding nodig. */
      card.querySelector('.klaasje-social__caption')?.remove();

      const link = post.permalink || post.link;
      if (link && card.tagName === 'A') {
        card.href = link;
        card.target = '_blank';
        card.rel = 'noopener';
      }

      /* De post blijft aan de kaart hangen; daarop herkent de klik-afhandeling
         dat er iets te vergroten valt. Een kaart met alleen zijn terugval
         heeft dit niet en volgt gewoon zijn link. Eigen naam met achtervoegsel,
         want kale namen op een element kunnen ingebouwde eigenschappen zijn
         (zie CLAUDE.md). */
      card.klaasjePost = post;

      card.querySelector('.klaasje-social__type')?.remove();
      const type = document.createElement('span');
      type.className = 'klaasje-social__type';
      type.innerHTML = typeIcoon(post);
      card.append(type);

      /* De donkere waas met het aantal likes, alleen op een muis. Eén
         element voor allebei: een lege sierdiv zou van Dawn's base.css
         display:none krijgen (div:empty). */
      card.querySelector('.klaasje-social__hover')?.remove();
      if (typeof post.like_count === 'number') {
        const laag = document.createElement('span');
        laag.className = 'klaasje-social__hover';
        laag.innerHTML = HART + '<span>' + telling(post.like_count) + '</span>';
        card.append(laag);
      }
    });
  }

  /* Staat er nergens een Instagram-link ingevuld, dan maken we hem uit de
     accountnaam die de feed bij elke post meestuurt. Een ingevulde link
     wint altijd. */
  function zetProfiel(fan, posts) {
    const link = fan.querySelector('[data-klaasje-insta]');
    if (!link || link.hasAttribute('href')) return;
    const naam = posts.find((p) => p && p.username)?.username;
    if (!naam || !/^[A-Za-z0-9._]+$/.test(naam)) return;
    link.href = 'https://www.instagram.com/' + naam + '/';
    link.target = '_blank';
    link.rel = 'noopener';
  }

  async function loadFeed(url, cards, fan) {
    const stop = new AbortController();
    const timer = setTimeout(() => stop.abort(), FEED_TIMEOUT);
    try {
      const res = await fetch(url, { signal: stop.signal });
      if (!res.ok) return;
      const posts = feedPosts(await res.json());
      if (fan) zetProfiel(fan, posts);
      await Promise.all(
        cards.slice(0, posts.length).map((card, i) => fillCard(card, posts[i]))
      );

      /* Wat er nu werkelijk op de wand staat, in volgorde. Een post die
         niet geladen is, staat er niet bij: dan hangt zijn kaart nog aan
         de terugval en hoort hij ook niet in het bladeren. */
      viewerPosts = cards.map((c) => c.klaasjePost).filter(Boolean);
      viewerPosts.forEach((post, i) => {
        const card = cards.find((c) => c.klaasjePost === post);
        if (card) card.klaasjeIndex = i;
      });
    } catch (e) {
      /* Stil: de kaarten staan er al. */
    } finally {
      clearTimeout(timer);
    }
  }

  /* ── De post vergroot bekijken ──────────────────────────────
     Een klik op een kaart opent de post op de pagina zelf in plaats van
     naar Instagram te springen: een reel speelt af, een foto staat groot,
     en linksonder staat het aantal likes. Het scherm eromheen valt weg.

     Zonder JS, of op een kaart die alleen zijn terugval draagt, blijft de
     kaart gewoon een link naar Instagram. Dat is met opzet: de vergroting
     is een extraatje, geen voorwaarde.

     De laag hangt aan de body en niet in de sectie, want de sectie staat
     op overflow: hidden voor de wand. Hij wordt één keer gebouwd bij de
     eerste klik: pagina's zonder feed dragen zo geen dode markup. */
let viewer = null;
  let viewerHerkomst = null;
  /* De posts die op de wand staan, in dezelfde volgorde als de kaarten.
     Daarin bladert de vergroting, dus je komt nooit een post tegen die je
     op de wand niet had kunnen aanwijzen. */
  let viewerPosts = [];
  let viewerIndex = 0;
  /* Een veeg eindigt in een klik op wat eronder ligt. Zonder deze vlag
     zou bladeren met een veeg je meteen naar Instagram sturen. */
  let viewerGeveegd = false;

  function maakKlikbaar(media) {
    if (!media) return;
    media.setAttribute('role', 'link');
    media.tabIndex = 0;
    media.setAttribute('aria-label', 'bekijk op Instagram');
  }

  function naarInstagram() {
    const post = viewerPosts[viewerIndex];
    const link = post && (post.permalink || post.link);
    if (link) window.open(link, '_blank', 'noopener');
  }

  function bouwViewer() {
    const laag = document.createElement('div');
    laag.className = 'klaasje-social__viewer';
    laag.setAttribute('role', 'dialog');
    laag.setAttribute('aria-modal', 'true');
    laag.setAttribute('aria-label', 'post op Instagram');
    laag.hidden = true;
    laag.innerHTML =
      '<button type="button" class="klaasje-social__viewer-sluit" aria-label="sluiten">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">'
      + '<path d="M6 6l12 12M18 6L6 18"/></svg></button>'
      + '<button type="button" class="klaasje-social__viewer-pijl klaasje-social__viewer-pijl--vorige" aria-label="vorige post">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<polyline points="15 18 9 12 15 6"/></svg></button>'
      + '<div class="klaasje-social__viewer-frame" data-frame></div>'
      + '<button type="button" class="klaasje-social__viewer-pijl klaasje-social__viewer-pijl--volgende" aria-label="volgende post">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<polyline points="9 18 15 12 9 6"/></svg></button>';

    // Klikken naast de post sluit; klikken op de post zelf niet.
    laag.addEventListener('click', (e) => {
      if (e.target === laag) sluitViewer();
    });

    /* Op het frame en niet op het beeld zelf: het beeld wordt bij elke
       post vervangen, en bij een video die niet laadt nog een keer. */
    const frame = laag.querySelector('[data-frame]');
    frame.addEventListener('click', (e) => {
      if (!e.target.closest('.klaasje-social__viewer-media[role="link"]')) return;
      if (viewerGeveegd) return;
      naarInstagram();
    });
    frame.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      if (!e.target.closest('.klaasje-social__viewer-media[role="link"]')) return;
      naarInstagram();
    });
    laag.querySelector('.klaasje-social__viewer-sluit').addEventListener('click', sluitViewer);
    laag.querySelector('.klaasje-social__viewer-pijl--vorige')
      .addEventListener('click', () => blader(-1));
    laag.querySelector('.klaasje-social__viewer-pijl--volgende')
      .addEventListener('click', () => blader(1));

    /* Vegen om te bladeren, op dezelfde drempel als de wand zelf. De
       laatste positie wordt bij elke beweging onthouden, want op iOS
       eindigt een veeg soms in pointercancel zonder bruikbare positie. */
    let startX = null;
    let laatsteX = null;
    laag.addEventListener('pointerdown', (e) => {
      startX = laatsteX = e.clientX;
      viewerGeveegd = false;
    }, { passive: true });
    laag.addEventListener('pointermove', (e) => {
      if (startX !== null) laatsteX = e.clientX;
    }, { passive: true });
    const eind = () => {
      if (startX === null) return;
      const dx = laatsteX - startX;
      startX = null;
      if (Math.abs(dx) > SWIPE) {
        viewerGeveegd = true;
        blader(dx < 0 ? 1 : -1);
      }
    };
    laag.addEventListener('pointerup', eind, { passive: true });
    laag.addEventListener('pointercancel', eind, { passive: true });

    document.body.append(laag);
    return laag;
  }

  /* Eén post in het frame zetten. Wordt ook bij het bladeren gebruikt,
     dus alles wat van de vorige post was moet hier weg. */
  function toonPost(index) {
    const post = viewerPosts[index];
    if (!post) return;
    viewerIndex = index;

    const frame = viewer.querySelector('[data-frame]');
    frame.querySelector('video')?.pause();
    frame.textContent = '';

    const isVideo = post.media_type === 'VIDEO' && post.media_url;
    if (isVideo) {
      const video = document.createElement('video');
      video.className = 'klaasje-social__viewer-media';
      video.src = post.media_url;
      video.poster = post.thumbnail_url || '';
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      /* Gedempt starten is geen keuze: een browser weigert een video met
         geluid die vanzelf begint, en dan speelt hij helemaal niet. */
      video.muted = true;
      frame.append(video);

      const geluid = document.createElement('button');
      geluid.type = 'button';
      geluid.className = 'klaasje-social__viewer-geluid';
      const teken = () => {
        geluid.setAttribute('aria-label', video.muted ? 'geluid aan' : 'geluid uit');
        geluid.innerHTML = video.muted ? LUIDSPREKER_UIT : LUIDSPREKER;
      };
      geluid.addEventListener('click', () => {
        video.muted = !video.muted;
        if (!video.muted) video.play().catch(() => {});
        teken();
      });
      teken();
      frame.append(geluid);

      /* De film-URL's van Instagram zijn ondertekend en verlopen. Lukt het
         afspelen niet, dan tonen we de still in plaats van een zwart vlak. */
      video.addEventListener('error', () => {
        if (!post.thumbnail_url) return;
        geluid.remove();
        const img = document.createElement('img');
        img.className = 'klaasje-social__viewer-media';
        img.src = post.thumbnail_url;
        img.alt = feedAlt(post);
        if (post.permalink || post.link) maakKlikbaar(img);
        video.replaceWith(img);
      });
    } else {
      const img = document.createElement('img');
      img.className = 'klaasje-social__viewer-media';
      img.src = post.media_url || post.thumbnail_url || '';
      img.alt = feedAlt(post);
      frame.append(img);
    }

    /* Nog een keer klikken op de post gaat naar de post op Instagram,
       en het icoontje rechtsboven is diezelfde link, zichtbaar. Het
       geluidsknopje en het hartje liggen ernaast en niet erin, dus die
       doen gewoon hun eigen ding. */
    const link = post.permalink || post.link;
    if (link) {
      maakKlikbaar(frame.querySelector('.klaasje-social__viewer-media'));

      const type = document.createElement('a');
      type.className = 'klaasje-social__viewer-type';
      type.href = link;
      type.target = '_blank';
      type.rel = 'noopener';
      type.setAttribute('aria-label', 'bekijk op Instagram');
      type.innerHTML = typeIcoon(post);
      frame.append(type);
    }

    if (typeof post.like_count === 'number') {
      const likes = document.createElement('span');
      likes.className = 'klaasje-social__viewer-likes';
      likes.innerHTML = HART + '<span>' + telling(post.like_count) + '</span>';
      frame.append(likes);
    }

    // Met één post valt er niets te bladeren; dan geen pijlen.
    const alleen = viewerPosts.length < 2;
    viewer.querySelectorAll('.klaasje-social__viewer-pijl')
      .forEach((knop) => { knop.hidden = alleen; });
  }

  /* Rond: voorbij de laatste kom je weer bij de eerste, net als de wand. */
  function blader(stap) {
    if (viewerPosts.length < 2) return;
    const n = viewerPosts.length;
    toonPost(((viewerIndex + stap) % n + n) % n);
  }

  function openViewer(index, herkomst) {
    if (!viewerPosts.length) return;
    if (!viewer) viewer = bouwViewer();
    viewerHerkomst = herkomst || null;

    toonPost(index);
    viewer.hidden = false;
    document.body.classList.add('klaasje-social-vast');
    viewer.querySelector('.klaasje-social__viewer-sluit').focus();
    document.addEventListener('keydown', opToets);
  }

  function sluitViewer() {
    if (!viewer || viewer.hidden) return;
    viewer.hidden = true;
    // De video echt stoppen: verborgen doorspelen kost data en geluid.
    viewer.querySelector('video')?.pause();
    viewer.querySelector('[data-frame]').textContent = '';
    document.body.classList.remove('klaasje-social-vast');
    document.removeEventListener('keydown', opToets);
    viewerHerkomst?.focus();
    viewerHerkomst = null;
  }

  function opToets(e) {
    if (e.key === 'Escape') sluitViewer();
    else if (e.key === 'ArrowLeft') blader(-1);
    else if (e.key === 'ArrowRight') blader(1);
  }


  class KlaasjeSocialFan extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-klaasje-stage]');
      this.cards = Array.from(this.querySelectorAll('.klaasje-social__card'));
      this.total = this.cards.length;
      if (!this.stage || !this.total) return;

      /* Schuiven kan altijd, ook met zeven of minder kaarten: op een
         telefoon zie je er maar drie, dus de rest moet bereikbaar zijn.
         De wand draait dan rond. */
      this.slotCount = Math.min(this.total, MAX_VISIBLE);
      this.offset = (MAX_VISIBLE - this.slotCount) >> 1;
      this.mid = this.slotCount >> 1;
      this.center = this.total >> 1;
      this.dots = Array.from(this.querySelectorAll('.klaasje-social__dot'));
      this.visible = new Map();
      this.busy = false;
      this.stepDir = 0;
      this.swiped = false;

      this.map();
      this.prev = new Map(this.visible);
      this.bind();

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduced && 'IntersectionObserver' in window) this.enter();

      // Niet afwachten: de wand werkt ook zonder dat dit ooit terugkomt.
      const feed = this.dataset.klaasjeFeed;
      if (feed) this.watchFeed(feed);
    }

    disconnectedCallback() {
      this.io?.disconnect();
      this.feedIo?.disconnect();
      clearTimeout(this.safety);
    }

    /* De feed pas ophalen als de wand in de buurt komt. De homepage draagt
       de hero met zijn frames al; zeven foto's van Instagram erbovenop
       laden terwijl de bezoeker nog bovenaan staat, helpt niemand. Een
       ruime marge, zodat ze er staan voor je er bent. */
    watchFeed(url) {
      const start = () => {
        this.feedIo?.disconnect();
        loadFeed(url, this.cards, this);
      };
      if (!('IntersectionObserver' in window)) {
        start();
        return;
      }
      this.feedIo = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) start();
        },
        { rootMargin: '300px' }
      );
      this.feedIo.observe(this);
    }

    /* Diep weggezakt tot de sectie in beeld komt. De klasse zet de kaarten
       op hun beginstand; hem weghalen laat ze naar voren komen. */
    enter() {
      this.stage.classList.add('is-entry');
      const open = () => {
        this.io?.disconnect();
        clearTimeout(this.safety);
        this.stage.classList.remove('is-entry');
      };
      this.io = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) open();
        },
        { threshold: 0.2 }
      );
      this.io.observe(this);
      // Noodrem: gaat de waarnemer om wat voor reden dan ook niet af, dan
      // komt hij alsnog. Beter een animatie missen dan een lege plek.
      this.safety = setTimeout(open, 2500);
    }

    bind() {
      this.querySelector('[data-klaasje-prev]')?.addEventListener('click', () => this.cycle(-1));
      this.querySelector('[data-klaasje-next]')?.addEventListener('click', () => this.cycle(1));

      /* Vegen en slepen. De laatste positie wordt bij elke beweging
         onthouden, want op iOS eindigt een veeg soms in pointercancel in
         plaats van pointerup, en die draagt geen bruikbare positie. */
      let startX = null;
      let lastX = null;
      this.stage.addEventListener('pointerdown', (e) => {
        startX = lastX = e.clientX;
        this.swiped = false;
      }, { passive: true });
      this.stage.addEventListener('pointermove', (e) => {
        if (startX !== null) lastX = e.clientX;
      }, { passive: true });
      const end = () => {
        if (startX === null) return;
        const dx = lastX - startX;
        startX = null;
        if (Math.abs(dx) > SWIPE) {
          this.swiped = true;
          this.cycle(dx < 0 ? 1 : -1);
        }
      };
      this.stage.addEventListener('pointerup', end, { passive: true });
      this.stage.addEventListener('pointercancel', end, { passive: true });

      // een veeg die op een kaart begon mag niet als klik op die link doorgaan
      this.stage.addEventListener('click', (e) => {
        if (!this.swiped) return;
        e.preventDefault();
        e.stopPropagation();
        this.swiped = false;
      }, true);

      /* Een gewone klik op een kaart met een post erachter opent hem op de
         pagina in plaats van bij Instagram. Draagt de kaart geen post (nog
         niet gevuld, of alleen zijn terugval), dan gebeurt hier niets en
         volgt de browser de link. */
      this.stage.addEventListener('click', (e) => {
        const card = e.target.closest?.('.klaasje-social__card');
        if (!card || !card.klaasjePost) return;
        e.preventDefault();
        openViewer(card.klaasjeIndex || 0, card);
      });
    }

    /* Welke kaart staat op welke plek op de wand */
    map() {
      this.visible = new Map();
      for (let slot = 0; slot < this.slotCount; slot++) {
        const index = (((this.center + slot - this.mid) % this.total) + this.total) % this.total;
        this.visible.set(index, slot);
      }
    }

    /* Minder dan zeven kaarten: het middelste stuk van dezelfde wand.
       Liquid rekent hier hetzelfde, zodat de rusttoestand die in de HTML
       staat precies overeenkomt met wat deze JS eruit zou halen. */
    config(slot) {
      return SLOTS[this.offset + slot];
    }

    place(card, { x, y, r, t, s = 1, z, opacity = 1, jump = false }) {
      // jump: eerst zonder animatie naar de startplek, dan pas bewegen
      if (jump) card.style.transition = 'none';
      // De CSS geeft elke kaart een oplopende vertraging voor het
      // binnenkomen (nth-child). Bij het schuiven moet die weg, anders
      // blijft de zevende kaart 0,36s staan terwijl de rest al beweegt.
      card.style.transitionDelay = '0s';
      card.style.setProperty('--fx', x);
      card.style.setProperty('--fy', y);
      card.style.setProperty('--fr', r);
      card.style.setProperty('--ft', t);
      card.style.setProperty('--fs', s);
      card.style.opacity = String(opacity);
      card.style.zIndex = String(z);
      if (jump) {
        card.getBoundingClientRect(); // reflow forceren
        card.style.transition = '';
      }
    }

    cycle(step) {
      if (this.busy || this.total < 2) return;
      this.busy = true;
      // Niet this.dir: dat is de ingebouwde tekstrichting van HTMLElement
      // (zie CLAUDE.md), die slikt een getal in en leest terug als "".
      this.stepDir = step;
      this.center = (((this.center + step) % this.total) + this.total) % this.total;
      this.map();
      this.render();
      setTimeout(() => { this.busy = false; }, 600);
    }

    render() {
      this.cards.forEach((card, i) => {
        const slot = this.visible.get(i);
        const was = this.prev.get(i);

        if (slot === undefined) {
          // buiten de wand: naar de kant waar hij verdwijnt, dieper en
          // verder weggedraaid
          const side = this.stepDir === 1 ? -1 : 1;
          if (was !== undefined) {
            this.place(card, { x: side * OUT, y: 0, r: side * -60, t: OUT_T, z: 0, opacity: 0 });
          } else if (!card.dataset.parked) {
            this.place(card, { x: 0, y: 0, r: 0, t: -1, z: 0, opacity: 0, jump: true });
            card.dataset.parked = '1';
          }
          return;
        }
        delete card.dataset.parked;

        const base = this.config(slot);

        /* Binnenkomen: nieuw in beeld, of van de ene kant van de wand naar
           de andere gesprongen (met zeven of minder kaarten draait de wand
           rond). Dan eerst zonder animatie buiten beeld zetten aan de kant
           waar hij vandaan komt, en pas dan naar zijn plek. */
        const entering = this.stepDir !== 0 && (was === undefined || Math.abs(was - slot) > 1);
        if (entering) {
          const side = this.stepDir === 1 ? 1 : -1;
          this.place(card, { x: side * OUT, y: 0, r: side * 60, t: OUT_T, z: base.z, opacity: 0, jump: true });
        }
        this.place(card, base);
      });

      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.center));

      // Vanaf hier is dit de rusttoestand voor de volgende schuif.
      this.prev = new Map(this.visible);
      this.stepDir = 0;
    }
  }

  customElements.define('klaasje-social-fan', KlaasjeSocialFan);
})();
